import { render, staticRenderFns } from "./suggestinput.vue?vue&type=template&id=45f8af07&"
import script from "./suggestinput.vue?vue&type=script&lang=js&"
export * from "./suggestinput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sergey/projects/www/alfa-b2b/htdocs/local/templates/b2bportal/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('45f8af07', component.options)
    } else {
      api.reload('45f8af07', component.options)
    }
    module.hot.accept("./suggestinput.vue?vue&type=template&id=45f8af07&", function () {
      api.rerender('45f8af07', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/scripts/vue/components/suggestinput.vue"
export default component.exports